const camelToKebab = (s: string): string =>
  s.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();

export type VerifyState = Record<string, string | number | boolean | null | undefined>;

/**
 * Emits data-verify-* attributes describing a unit's state.
 * Returns {} in production so component code stays clean and tree-shakes the contract surface.
 */
export function verifyAttrs(
  unitId: string,
  state: VerifyState = {},
): Record<string, string> {
  if (!import.meta.env.DEV) return {};
  const out: Record<string, string> = { "data-verify-unit": unitId };
  for (const [key, value] of Object.entries(state)) {
    if (value === undefined || value === null) continue;
    out[`data-verify-${camelToKebab(key)}`] = String(value);
  }
  return out;
}
